import { SET_INDEX_URLS } from "../action_types";
import store from "../store";

const setIndexUrls = urls => ({
    type: SET_INDEX_URLS,
    urls,
});

export const boundSetIndexUrls = urls => store.dispatch(setIndexUrls(urls));